import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from '../../common/noDataComponent';
import OldStyleSubsection from '../../common/oldStyleSubsection';
import EsgScoreAverage from './esgScoreAverage';
import EsgScoreStatistics, { ESG_SCORE_SECTION_TYPE } from './esgScoreStatistics';

class ESGScoreSection extends React.Component {

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? <NoDataComponent /> : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        switch (this.props.sectionId) {
            case ESG_SCORE_SECTION_TYPE.detail:
                return this.renderDetail(data);
            case ESG_SCORE_SECTION_TYPE.scoreE:
            case ESG_SCORE_SECTION_TYPE.scoreS:
            case ESG_SCORE_SECTION_TYPE.scoreG:
                return this.renderScore(this.props.sectionId, data);
            default:
                return <NoDataComponent />;
        }
    }

    renderDetail = (data) => {
        const primaryAttrCountry = this.getPrimaryAttrCountry();

        return (
            <div className="columns is-tablet is-multiline is-centered">
                <div className="column is-4-widescreen is-12-mobile is-4">
                    <EsgScoreStatistics section={ESG_SCORE_SECTION_TYPE.detail} data={data.market} score={data.value} primaryAttrCountry={primaryAttrCountry} />
                </div>
                <div className="column is-4-widescreen is-12-mobile is-4">
                    <EsgScoreAverage data={{ market_avg: data.market.n_avg, sector_avg: data.sector.n_avg }} sectorIdentificator={data.sectorIdentificator} primaryAttrCountry={primaryAttrCountry} />
                </div>
                <div className="column is-4-widescreen is-12-mobile is-4">
                    <EsgScoreStatistics section={ESG_SCORE_SECTION_TYPE.detail} data={data.sector} score={data.value} isSector={true} sectorIdentificator={data.sectorIdentificator} primaryAttrCountry={primaryAttrCountry} />
                </div>
            </div>
        )
    }

    renderScore = (sectionId, data) => {
        const primaryAttrCountry = this.getPrimaryAttrCountry();

        return (
            <>
                <div className={classnames('esg-score-section', {
                    'e': sectionId === ESG_SCORE_SECTION_TYPE.scoreE,
                    's': sectionId === ESG_SCORE_SECTION_TYPE.scoreS,
                    'g': sectionId === ESG_SCORE_SECTION_TYPE.scoreG
                })}>
                    <EsgScoreStatistics section={sectionId} data={data.market} score={data.value} primaryAttrCountry={primaryAttrCountry} />
                    <EsgScoreStatistics section={sectionId} data={data.sector} score={data.value} isSector={true} sectorIdentificator={data.sectorIdentificator} primaryAttrCountry={primaryAttrCountry} />
                </div>
                {this.renderSubsections()}
            </>
        )
    };

    renderSubsections = () => {
        const subsections = this.props.sections.find(s => s.id === this.props.sectionId).subsections;

        return (
            <div>
                {subsections
                    .sort((a, b) => a.orderId - b.orderId)
                    .map(s => <OldStyleSubsection isBold
                        key={s.id}
                        sectionId={this.props.sectionId}
                        subsectionId={s.id}
                        subsectionName={`${s.name} ${this.props.data.sectorIdentificator}`}
                        subsectionData={{ type: s.params.type }}
                    />)}
            </div>
        )
    }

    getPrimaryAttrCountry = () => {
        const { id } = this.props;
        const { entityInfos } = this.props.entity;

        if (entityInfos && entityInfos[id] && entityInfos[id].result && entityInfos[id].result.reports) {
            switch (entityInfos[id].result.reports.primaryAttr) {
                case 1:
                    return 'CZ';
                case 2:
                    return 'SK';
                default:
                    return undefined;
            }
        } else {
            return undefined;
        }
    }
}

export default connect(state => ({ ...state.report, entity: state.entityIdentRow }))(ESGScoreSection);